import React from 'react'
import { Ratio } from 'react-bootstrap';

const Testimonios = ({ embed }) => {
    return (
        <div>
            <section className="col mainClass__body ">
                <div className="body__embed rounded-3" style={{ height: "auto" }}>
                    <Ratio aspectRatio="16x9">
                        <iframe
                            src={embed}
                            title="Testimonio"
                            loading="lazy"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            referrerPolicy="strict-origin-when-cross-origin"
                            style={{ border: 0 }}
                        />
                    </Ratio>
                </div>
            </section>
        </div>
    )
}

export default Testimonios
